import { Grid, Typography } from '@mui/material';
import { WithStyles, useTheme, withStyles } from '@mui/styles';
import { BasicButton } from '@tassat/button';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

import { muiStyles } from './transactionStyles';

type TransactionTimeoutProps = WithStyles<typeof muiStyles>;

export function TransactionTimeoutComponent (props: TransactionTimeoutProps) {
    const { classes } = props;

    const theme = useTheme<ApplicationMuiTheme>();
    const { clientName = 'Tassat' } = theme?.app?.clientTheme.names || {};
    const {
        email = 'support@tassatpay.com',
        phoneDirect,
        phoneTollFree
    } = theme?.app?.clientTheme.support.contactInfo || {};

    return (
        <Grid
            alignItems='center'
            className={classes.root}
            container
            direction='column'
            spacing={0}
        >
            <Typography
                align='center'
                className={`${classes.paddedText} ${classes.submitText}`}
                variant='h5'
            >
                Your transaction timed out.
            </Typography>
            <Typography
                align='center'
                className={`${classes.smallPaddedText} ${classes.disclaimerText}`}
                variant='body1'
            >
                Your connection to the server was interrupted and your transaction may or may not have been submitted.
                Please refresh this page and review your Transaction History. If your transaction was not processed, please
                resubmit.
            </Typography>
            <Typography
                align='center'
                className={`${classes.smallPaddedText} ${classes.disclaimerText}`}
                variant='body1'
            >
                For continued problems please call {clientName} Client Services at: <br />
                <a
                    href={`mailto:${email}`}
                    style={{ textDecoration: 'none' }}
                >{email}
                </a><br />
                {phoneDirect && `Direct ${phoneDirect}`} {phoneDirect && phoneTollFree && '|'} {phoneTollFree && `Toll Free ${phoneTollFree}`}
            </Typography>
            <Grid
                className={classes.buttonContainer}
                container
                direction='row'
                item
                justifyContent='center'
                spacing={0}
            >
                <BasicButton
                    onClick={() => window.location.reload()}
                    text='REFRESH'
                    type='main'
                />
            </Grid>
        </Grid>
    );
}

const TransactionTimeout = withStyles(muiStyles)(TransactionTimeoutComponent);
export { TransactionTimeout };